import React, { useCallback, useState } from "react";
import { Alert, SearchInput } from "@alm/flow-ds/components";
import { useTranslation } from "react-i18next";
import PageHeader from "components/PageHeader";
import CreateForm from "../CreateForm";
import DefinitionsList from "../DefinitionsList";
import UploadForm from "../UploadForm";

export default function FormStart() {
	const { t } = useTranslation();
	const [searchBox, setSearchBox] = useState("");
	const [searchValue, setSearchValue] = useState("");
	const [alert, setAlert] = useState("");

	if (process.env.NODE_ENV === "production") {
		window.onbeforeunload = null;
	}

	const onChangeEvent = useCallback(
		(event: React.ChangeEvent<HTMLInputElement>) => {
			if (event.target.value !== "") {
				setSearchBox(event.target.value);
			} else {
				setSearchBox(event.target.value);
				setSearchValue(event.target.value);
			}
		},
		[]
	);

	return (
		<div className="container">
			<div className="fixed-header-container">
				<PageHeader title={t("formDesigner.title")}>
					<div className="form-controls__buttons">
						<CreateForm />
						<UploadForm />
					</div>
				</PageHeader>
				{alert !== "" && (
					// TODO: Could move these bits of string manipulation into a useMemo perhaps? Then they don't get constructed every re-render
					<Alert
						className="mb-4"
						title={t(`alerts.${alert.split("/")[0]}.title`, {
							name: alert.split("/")[1],
						})}
						block={true}
						description={t(
							`alerts.${alert.split("/")[0]}.description`,
							{ name: alert.split("/")[1] }
						)}
						status={
							alert.split("/")[0] === "deleteError"
								? "error"
								: "success"
						}
						onClose={() => setAlert("")} // TODO: don't need anon function
					/>
				)}
				<div className="form-controls">
					<div className="search-bar">
						<SearchInput
							label={t("formDesigner.labels.search")}
							onSearch={() => setSearchValue(searchBox)} // TODO: don't need anon function
							onChange={event => onChangeEvent(event)} // TODO: don't need anon function
							value={searchBox}
						/>
					</div>
				</div>
			</div>
			<DefinitionsList
				search={searchValue}
				setAlert={setAlert}
				alert={alert}
			/>
		</div>
	);
}
